import { mutationTypes } from '@/core/constants'
import { FiltroUtils } from '@/core/utils'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	[mutationTypes.ADESAO.ITENS.RESET_FILTRO_LISTAGEM](state) {
		FiltroUtils.limparFiltroAvancado(state.filtro)
	},
	[mutationTypes.ADESAO.ITENS.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},
	[mutationTypes.ADESAO.ITENS.RESET_PAGINACAO_LISTAGEM](state) {
		state.paginacao = paginacaoListagem(['seq'], 5, 'ASC')
	},
	[mutationTypes.ADESAO.ITENS.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},
	[mutationTypes.ADESAO.ITENS.SET_ITENS_SELECIONADOS](state, itens) {
		state.itensSelecionados = itens
	},
	[mutationTypes.ADESAO.ITENS.RESET_ITENS_SELECIONADOS](state) {
		state.itensSelecionados = []
	},
	[mutationTypes.ADESAO.ITENS.SET_TODOS_ITENS_SELECIONADOS](state, flag) {
		state.isSelecionouTodosItensAdesao = flag
	},
}
